import { AfterViewInit, Component, EventEmitter, inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { PDFDocumentProxy, PdfViewerModule } from 'ng2-pdf-viewer';
import { MaterialModule } from '../../material/material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { CommonModule } from '@angular/common';
import { isValidNumber } from '@pineapplelab/util';
import { TimerService } from '../../services/timer/timer.service';
import { PdfTrackerService } from '../../services/pdf-tracker/pdf-tracker.service';

@Component({
	selector: 'app-pdf-viewer',
	standalone: true,
	imports: [
		PdfViewerModule,
		MaterialModule,
		PipesModule,
		CommonModule
	],
	templateUrl: './pdf-viewer.component.html',
	styleUrl: './pdf-viewer.component.scss'
})
export class PdfViewerComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	private readonly timerService = inject(TimerService);
	private readonly pdfTracker = inject(PdfTrackerService);

	@Input() src: string = null;
	@Input() pdfId: string = null;
	@Input() showLoader: boolean = true;
	@Input() timer: number = null;
	@Input() startAt: number = 1;
	@Input() showZoomOptions: boolean = true;

	@Output() timeout = new EventEmitter<void>();

	loading: boolean = true;
	zoomTo: number = 1;
	isDragging = false;
	startX = 0;
	scrollLeft = 0;
	pdfContainer: any;
	viewerStyles = {
		'display': 'block',
		'width': '80%',
		'height': '500px'
	}

	ngOnInit(): void {
		if (isValidNumber(this.timer)) {
			this.start();
		}
	}

	ngAfterViewInit(): void {
		this.pdfContainer = document.querySelector('.ng2-pdf-viewer-container');
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes?.['src']?.previousValue && !!changes?.['src']?.currentValue && changes?.['src']?.previousValue !== changes?.['src']?.currentValue && isValidNumber(this.timer)) {
			this.start();
		}

		if (changes?.['pdfId'] && changes['pdfId'].currentValue !== changes['pdfId'].previousValue) {
			this.pdfTracker.endSession();
			this.pdfTracker.startSession(this.pdfId);
		}
	}

	ngOnDestroy(): void {
		this.pdfTracker.endSession();
	}

	onPdfLoaded(pdf: PDFDocumentProxy): void {
		this.loading = false;
	}

	zoomIn() {
		this.zoomTo = this.zoomTo + 0.25;
	}

	zoomOut() {
		if (this.zoomTo > 1) {
			this.zoomTo = this.zoomTo - 0.25;
		}
	}

	onMouseDown(event: MouseEvent): void {
		if (!this.pdfContainer) {
			return;
		}
		event.preventDefault();
		this.isDragging = true;
		this.pdfContainer.classList.add('grabbing');
		this.startX = event.pageX - this.pdfContainer.offsetLeft;
		this.scrollLeft = this.pdfContainer.scrollLeft;
	}

	onMouseUp(event: MouseEvent): void {
		if (!this.pdfContainer) {
			return;
		}
		this.isDragging = false;
		this.pdfContainer.classList.remove('grabbing');
	}

	onMouseMove(event: MouseEvent): void {
		if (!this.isDragging || !this.pdfContainer) {
			return;
		}
		event.preventDefault();
		const x = event.pageX - this.pdfContainer.offsetLeft;
		const walk = (x - this.startX) * 2; // Speed of scrolling
		this.pdfContainer.scrollLeft = this.scrollLeft - walk;
	}

	private start(): void {
		this.timerService.start(this.timer).then(() => this.timeout.emit());
	}

}
